import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { deprecation, isWebGLSupported } from '@pixi/utils';
import { UniformGroup } from './shader/UniformGroup.mjs';
import { Matrix } from '@pixi/math';
import { ExtensionType, extensions } from '@pixi/extensions';
import { settings } from '@pixi/settings';
import { SystemManager } from './system/SystemManager.mjs';
var _Renderer = /*#__PURE__*/function (_SystemManager) {
  _inherits(_Renderer, _SystemManager);
  var _super = _createSuper(_Renderer);
  function _Renderer(options) {
    var _options$background;
    var _this;
    _classCallCheck(this, _Renderer);
    _this = _super.call(this);
    options = Object.assign({}, settings.RENDER_OPTIONS, options);
    _this.gl = null;
    _this.CONTEXT_UID = 0;
    _this.globalUniforms = new UniformGroup({
      projectionMatrix: new Matrix()
    }, true);
    var systemConfig = {
      runners: ["init", "destroy", "contextChange", "resolutionChange", "reset", "update", "postrender", "prerender", "resize"],
      systems: _Renderer.__systems,
      priority: ["_view", "textureGenerator", "background", "_plugin", "startup", "context", "state", "texture", "buffer", "geometry", "framebuffer", "transformFeedback", "mask", "scissor", "stencil", "projection", "textureGC", "filter", "renderTexture", "batch", "objectRenderer", "_multisample"]
    };
    _this.setup(systemConfig);
    if ("useContextAlpha" in options) {
      deprecation("7.0.0", "options.useContextAlpha is deprecated, use options.premultipliedAlpha and options.backgroundAlpha instead");
      options.premultipliedAlpha = options.useContextAlpha && options.useContextAlpha !== "notMultiplied";
      options.backgroundAlpha = options.useContextAlpha === false ? 1 : options.backgroundAlpha;
    }
    var startupOptions = {
      hello: options.hello,
      _plugin: _Renderer.__plugins,
      background: {
        alpha: options.backgroundAlpha,
        color: (_options$background = options.background) !== null && _options$background !== void 0 ? _options$background : options.backgroundColor,
        clearBeforeRender: options.clearBeforeRender
      },
      _view: {
        height: options.height,
        width: options.width,
        autoDensity: options.autoDensity,
        resolution: options.resolution,
        view: options.view
      },
      context: {
        antialias: options.antialias,
        context: options.context,
        powerPreference: options.powerPreference,
        premultipliedAlpha: options.premultipliedAlpha,
        preserveDrawingBuffer: options.preserveDrawingBuffer
      }
    };
    _this.startup.run(startupOptions);
    return _this;
  }
  _createClass(_Renderer, [{
    key: "render",
    value: function render(displayObject, options) {
      this.objectRenderer.render(displayObject, options);
    }
  }, {
    key: "resize",
    value: function resize(desiredScreenWidth, desiredScreenHeight) {
      this._view.resizeView(desiredScreenWidth, desiredScreenHeight);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.runners.reset.emit();
      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.renderTexture.bind();
      this.renderTexture.clear();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var removeView = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.runners.destroy.items.reverse();
      this.emitWithCustomOptions(this.runners.destroy, {
        _view: removeView
      });
      _get(_getPrototypeOf(_Renderer.prototype), "destroy", this).call(this);
    }
  }, {
    key: "plugins",
    get: function get() {
      return this._plugin.plugins;
    }
  }, {
    key: "multisample",
    get: function get() {
      return this._multisample.multisample;
    }
  }, {
    key: "width",
    get: function get() {
      return this._view.element.width;
    }
  }, {
    key: "height",
    get: function get() {
      return this._view.element.height;
    }
  }, {
    key: "resolution",
    get: function get() {
      return this._view.resolution;
    },
    set: function set(value) {
      this._view.resolution = value;
      this.runners.resolutionChange.emit(value);
    }
  }, {
    key: "autoDensity",
    get: function get() {
      return this._view.autoDensity;
    }
  }, {
    key: "view",
    get: function get() {
      return this._view.element;
    }
  }, {
    key: "screen",
    get: function get() {
      return this._view.screen;
    }
  }, {
    key: "lastObjectRendered",
    get: function get() {
      return this.objectRenderer.lastObjectRendered;
    }
  }, {
    key: "renderingToScreen",
    get: function get() {
      return this.objectRenderer.renderingToScreen;
    }
  }, {
    key: "rendererLogId",
    get: function get() {
      return "WebGL ".concat(this.context.webGLVersion);
    }
  }, {
    key: "clearBeforeRender",
    get: function get() {
      deprecation("7.0.0", "renderer.clearBeforeRender has been deprecated, please use renderer.background.clearBeforeRender instead.");
      return this.background.clearBeforeRender;
    }
  }, {
    key: "useContextAlpha",
    get: function get() {
      deprecation("7.0.0", "renderer.useContextAlpha has been deprecated, please use renderer.context.premultipliedAlpha instead.");
      return this.context.useContextAlpha;
    }
  }, {
    key: "preserveDrawingBuffer",
    get: function get() {
      deprecation("7.0.0", "renderer.preserveDrawingBuffer has been deprecated, we cannot truly know this unless pixi created the context");
      return this.context.preserveDrawingBuffer;
    }
  }, {
    key: "backgroundColor",
    get: function get() {
      deprecation("7.0.0", "renderer.backgroundColor has been deprecated, use renderer.background.color instead.");
      return this.background.color;
    },
    set: function set(value) {
      deprecation("7.0.0", "renderer.backgroundColor has been deprecated, use renderer.background.color instead.");
      this.background.color = value;
    }
  }, {
    key: "backgroundAlpha",
    get: function get() {
      deprecation("7.0.0", "renderer.backgroundAlpha has been deprecated, use renderer.background.alpha instead.");
      return this.background.color;
    },
    set: function set(value) {
      deprecation("7.0.0", "renderer.backgroundAlpha has been deprecated, use renderer.background.alpha instead.");
      this.background.alpha = value;
    }
  }, {
    key: "powerPreference",
    get: function get() {
      deprecation("7.0.0", "renderer.powerPreference has been deprecated, we can only know this if pixi creates the context");
      return this.context.powerPreference;
    }
  }, {
    key: "generateTexture",
    value: function generateTexture(displayObject, options) {
      return this.textureGenerator.generateTexture(displayObject, options);
    }
  }], [{
    key: "test",
    value: function test(options) {
      if (options !== null && options !== void 0 && options.forceCanvas) {
        return false;
      }
      return isWebGLSupported();
    }
  }]);
  return _Renderer;
}(SystemManager);
var Renderer = _Renderer;
Renderer.extension = {
  type: ExtensionType.Renderer,
  priority: 1
};
Renderer.__plugins = {};
Renderer.__systems = {};
extensions.handleByMap(ExtensionType.RendererPlugin, Renderer.__plugins);
extensions.handleByMap(ExtensionType.RendererSystem, Renderer.__systems);
extensions.add(Renderer);
export { Renderer };